import  { type ReactElement } from 'react';

import { Skeleton } from '@beeline/design-system-react/extracted-styles';

import clsx from 'clsx';

import styles from './styles.module.scss';
import type { HeaderSkeletonProps } from './types';

export const HeaderSkeleton = ({
  withBreadCums,
  withButton,
  isDialogHeader
}: HeaderSkeletonProps): ReactElement => {
  return (
    <div className={styles.loading}>
      {withBreadCums && <Skeleton className={styles.skeletonBreadcrumbs} />}
      <div className={styles.container}>
        {withButton && (
          <Skeleton
            className={clsx(
              styles.skeletonButton,
              isDialogHeader && styles.transform
          )}
          variant='circle' />
        )}
        <Skeleton className={styles.skeleton} />
      </div>
    </div>
  );
};
